import type { ProfileResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { ProfileQueryGateway } from './profile-query';

/**
 * Real HTTP implementation of the shared profile-read data layer. Path building is
 * kept 1:1 with the original `useInfiniteApi('/profiles')` (1-indexed server page,
 * `filters` serialised only when present) so the server sees identical requests.
 * Feature gateways spread this in.
 */
export const profileQueryHttp: ProfileQueryGateway = {
  fetchProfiles: async ({ filters, page, pageSize, favorite, q, licenceId, sort }) => {
    const serverPage = page + 1; // backend is 1-indexed
    let path = `/profiles?page=${serverPage}&limit=${pageSize}`;
    if (favorite) path += '&favorite=true';
    if (q?.trim()) path += `&q=${encodeURIComponent(q.trim())}`;
    if (licenceId) path += `&license_id=${encodeURIComponent(licenceId)}`;
    if (filters) path += `&filters=${encodeURIComponent(JSON.stringify(filters))}`;
    if (sort) path += `&sort_by=${sort.by}&sort_order=${sort.order}`;

    const res = await api.getRaw<ProfileResponse[]>(path);
    const rows = res.data ?? [];
    return { rows, total: res.pagination?.total ?? rows.length };
  },
};
